// extracted by mini-css-extract-plugin
module.exports = {"carousalWrap":"workstyles_carousalWrap__CznoK","worksHeading":"workstyles_worksHeading__2d7ZP","Wrapper":"workstyles_Wrapper__YSpxk"};